import { RANDOM_ROW_DEFAULT_COUNT } from "./constants";
import { createEmptyRow } from "./rowUtils";

const SAMPLE_ORGS = [
  "춘천시 자원봉사단",
  "후평동 주민센터",
  "도청 보건과",
  "강릉시 민간지원단",
  "원주시 자원봉사협의회",
];
const SAMPLE_DEPTS = ["1팀", "2팀", "3팀", "현장반", "지원반"];
const SAMPLE_RANKS = ["팀원", "팀장", "반장"];
const SAMPLE_DUTIES = ["급식지원", "물품운송", "현장안내", "통역지원", "의료지원"];
const NAME_SYLLABLES = ["가", "나", "다", "라", "마", "바", "사", "아", "자", "차"];

function pick(list, index) {
  return list[index % list.length];
}

function randomPhone(index) {
  const mid = String(1000 + ((index * 137) % 9000)).padStart(4, "0");
  const last = String(1000 + ((index * 271) % 9000)).padStart(4, "0");
  return `000-${mid}-${last}`;
}

function randomName(index) {
  const a = pick(NAME_SYLLABLES, index);
  const b = pick(NAME_SYLLABLES, index + 3);
  const c = pick(NAME_SYLLABLES, index + 7);
  return `${a}${b}${c}`;
}

/**
 * 지원인력 일괄입력 — 시연·훈련용 랜덤 행 생성
 */
export function generateRandomRdvRows({
  count = RANDOM_ROW_DEFAULT_COUNT,
  defaultWorkplace = "",
  rdvMap,
  defaultRdvId,
}) {
  const n = Math.max(1, Math.min(parseInt(count, 10) || 10, 100));
  const workplace = String(defaultWorkplace || "").trim();
  const hit = workplace ? rdvMap?.get(workplace) : null;

  return Array.from({ length: n }, (_, i) =>
    createEmptyRow(i + 1, {
      workplace,
      rdvId: hit?.rdv_id ?? defaultRdvId ?? null,
      siteId: hit?.site_id ?? null,
      personType: "other",
      personTypeLabel: "비소방",
      porg: pick(SAMPLE_ORGS, i),
      pdept: pick(SAMPLE_DEPTS, i),
      prank: pick(SAMPLE_RANKS, i),
      pname: randomName(i),
      pphone: randomPhone(i),
      dutyDesc: pick(SAMPLE_DUTIES, i),
    }),
  );
}
